/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/mv_pseries_weighted_sum.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Converts a multivalued expression into a single-valued column by multiplying every element on the input list by its corresponding term in P-Series and computing the sum.
 *
 * @example
 * ROW a = [70.0, 45.0, 21.0, 21.0, 21.0]
 * | EVAL sum = MV_PSERIES_WEIGHTED_SUM(a, 1.5)
 * | KEEP sum
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'mv_pseries_weighted_sum',
  signatures: [
    {
      params: [
        {
          name: 'number',
          type: 'double',
          optional: false,
        },
        {
          name: 'p',
          type: 'double',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
